import { Endpoint } from '../endpoint';
import { JobResponse, JobId } from '@business/entities/job';

export function fetchJobs() {
  return Endpoint.get<JobResponse[]>(`@gc/jobs`);
}

export function dismissJob(jobId: JobId) {
  return Endpoint.post<void>(`@gc/jobs/dismiss/${jobId}`);
}
